import type {
  CommonResponseListConceptChipResponse,
  GetConceptChipsByCurriculumKeyParams,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'
import type { WithNullableOptionals } from '~/http/request'

import { adaptConceptChips } from './adapters'
import type { ConceptChip } from './schemas'

export type { GetConceptChipsByCurriculumKeyParams }
// 교재·기출·선택 조건은 서버가 nullable(`Set<Int>?`·`Boolean?`)로 받는다. 2026-10-13 백엔드 develop(cc5f60e17) 의
// concept/controller 의 getConceptChipsByCurriculumKey 로 확인.
export type ConceptChipsParams = WithNullableOptionals<GetConceptChipsByCurriculumKeyParams>

export const getConceptChips = async (
  params: ConceptChipsParams,
  meta?: RequestMeta,
): Promise<ConceptChip[]> => {
  const body = await httpClient().get<CommonResponseListConceptChipResponse>('/concept/chips', {
    params,
    meta,
  })
  return adaptConceptChips(body.data) ?? []
}
